<div class="discount-grid" [class.is-disabled]="disabled">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <p class="grid-titulo" [class.grid-titulo-secao]="padraoSecao">
      {{ titulo }}
      @if (tooltip) {
      <mat-icon class="material-symbols-outlined info-icon" [matTooltip]="tooltip" matTooltipPosition="above">info</mat-icon>
      }
    </p>
    <span [matTooltip]="tooltipAdicionar" matTooltipPosition="above">
      <button type="button" mat-button [class.btn-section]="padraoSecao" (click)="adicionar()"
        [disabled]="!podeAdicionar">
        <mat-icon>add</mat-icon> Adicionar
      </button>
    </span>
  </div>

  @for (item of items; track $index) {
  <div class="discount-row-wrapper">
    <div class="row w-100 g-2 align-items-center m-0">
      <div class="col-7 col-lg-7">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 no-bottom-space compact-input">
          <mat-label>Perfil</mat-label>
          <mat-select [ngModel]="item.idPerfil" (ngModelChange)="onPerfilChange($index, $event)" [disabled]="disabled">
            @for (p of perfisDisponiveis($index); track p.idPerfil) {
            <mat-option [value]="p.idPerfil">{{ p.nome }}</mat-option>
            }
          </mat-select>
          @if (perfisDisponiveis($index).length === 0) {
          <mat-icon matSuffix class="material-symbols-outlined info-icon" [matTooltip]="tooltipPerfilVazio($index)"
            matTooltipPosition="above">info</mat-icon>
          }
        </mat-form-field>
      </div>
      <div class="col-3 col-lg-3">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 no-bottom-space compact-input">
          <mat-label>Desconto</mat-label>
          <input matInput currencyMask [options]="percentMask" placeholder="0,00" [ngModel]="item.descontoMaximo"
            (ngModelChange)="onDescontoChange($index, $event)" [disabled]="disabled">
          <mat-icon matSuffix>percent</mat-icon>
        </mat-form-field>
      </div>
      <div class="col-2 col-lg-2 delete-col">
        <button type="button" mat-icon-button (click)="remover($index)" [disabled]="disabled"
          matTooltip="Remover">
          <mat-icon class="material-symbols-outlined">delete</mat-icon>
        </button>
      </div>
    </div>
  </div>
  }

  @if (items.length === 0) {
    @if (padraoSecao) {
    <div class="empty-state-bloco">
      <div class="empty-state-titulo">
        {{ textoVazio }}
        @if (perfis.length === 0) {
        <mat-icon class="material-symbols-outlined info-icon" matTooltip="Nenhum perfil cadastrado no sistema."
          matTooltipPosition="above">info</mat-icon>
        }
      </div>
      @if (textoVazioApoio) {
      <div class="empty-state-apoio">{{ textoVazioApoio }}</div>
      }
    </div>
    } @else {
    <div class="empty-state-grid">
      {{ textoVazio }}
      @if (perfis.length === 0) {
      <mat-icon class="material-symbols-outlined info-icon" matTooltip="Nenhum perfil cadastrado no sistema."
        matTooltipPosition="above">info</mat-icon>
      }
    </div>
    }
  }
</div>
